// extracted by mini-css-extract-plugin
module.exports = {"table":"table_table__3JIe-","isSites":"table_isSites__3WA2u","pagination":"table_pagination__3dacs"};